/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Product_ClassificationsInputs */

const vi_nav_product_classifications = /** @type {(inputs: Nav_Product_ClassificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân loại sản phẩm`)
};

/**

* @param {Nav_Product_ClassificationsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_product_classifications = /** @type {((inputs?: Nav_Product_ClassificationsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Product_ClassificationsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_product_classifications(inputs)
});